export default __webpack_public_path__ + "static/media/mercy.e9a95a36.png";